

import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';



function MenuMobEs({ changeLanguage, navigateTo }) {

    const navigate = useNavigate();

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isMenuCollapsed, setMenuCollapsed] = useState(true);


    const handleToggleClick = () => {
        setMenuCollapsed(!isMenuCollapsed);

        const navbarCollapse = document.querySelector('.navbar-collapse');
        navbarCollapse.style.display = isMenuCollapsed ? 'block' : 'none';

        const subMenus = document.querySelectorAll('.sub-menuMob');
        subMenus.forEach((submenu) => {
            submenu.style.display = 'none';
        });
    };

    const handleSubMenuClick = (e) => {
        e.preventDefault();
        const submenu = e.target.nextElementSibling;

        const otherSubMenus = document.querySelectorAll('.sub-menuMob');
        otherSubMenus.forEach((otherMenu) => {
            if (otherMenu !== submenu) {
                otherMenu.style.display = 'none';
            }
        });

        if (!isMenuCollapsed && submenu) {
            submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
        }


    };

    //Colapsar al hacer clic en enlaces
    const handleNavLinkClick = () => {
        setMenuCollapsed(true);
    };

    const handleResize = () => {
        setWindowWidth(window.innerWidth);

        if (window.innerWidth > 750) {
            setMenuCollapsed(true);
        }
    };

    useEffect(() => {
        const resizeHandler = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(handleResize, 100);
        };

        let resizeTimer;

        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    useEffect(() => {
        handleResize();
    }, [windowWidth]);

    useEffect(() => {
        // Asegurar que el menú esté colapsado al renderizar
        const navbarCollapse = document.querySelector('.navbar-collapse');
        navbarCollapse.style.display = isMenuCollapsed ? 'none' : 'block';

        const subMenus = document.querySelectorAll('.sub-menuMob');
        subMenus.forEach((submenu) => {
            submenu.style.display = 'none';
        });
    }, [isMenuCollapsed]);



    /* 00000000000000 Move var 0000000000000000000  */

    const [startY, setStartY] = useState(0);
    const [visible, setVisible] = useState(true);

    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        const currentY = e.touches[0].clientY;
        if (startY < currentY && !visible) {
            setVisible(true);
        } else if (startY > currentY && visible) {
            setVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('touchstart', handleTouchStart);
        window.addEventListener('touchmove', handleTouchMove);

        return () => {
            window.removeEventListener('touchstart', handleTouchStart);
            window.removeEventListener('touchmove', handleTouchMove);
        };
    }, [startY, visible]);


    return (

        <main>

            {/*================= TOPBARMOB =================*/}

            {/* <div className='topbarmob'> */}
            <div className={`topbarmob ${visible ? 'visible' : 'hidden'}`}>
                {/* <div style={{ display: 'flex', position: 'fixed', width: '100%' ,  justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#333', color: 'white', padding: '10px 20px 5px' }}> */}
                <Link to=""  > <span style={{ color: 'white', fontWeight: 'bold' }}> Moscú </span> </Link>
                {/*  <div style={{ fontSize: '18px' }}> Moscow </div> */}

                <div style={{ fontSize: '20px' }}>
                    <Link to="https://www.youtube.com/@PlanRusia" target="_blank"> <i className="fab fa-youtube" style={{ color: 'white', marginRight: '5px' }} ></i>  </Link>
                    <Link to="https://tiktok.com/@planrusia" target="_blank"> <i className="fab fa-tiktok" style={{ color: 'white', marginRight: '5px' }} ></i>  </Link>
                    <Link to="https://www.facebook.com/PlanRusia" target="_blank"> <i className="fab fa-facebook-f" style={{ color: 'white', marginRight: '5px' }} ></i>  </Link>
                    <Link to="https://instagram.com/plan.rusia" target="_blank"> <i className="fab fa-instagram" style={{ color: 'white', marginRight: '5px' }} ></i>  </Link>
                    <Link to="https://t.me/planrusia" target="_blank"> <i className="fab fa-telegram" style={{ color: 'white', marginRight: '5px' }} ></i> </Link>
                    <Link to="https://x.com/planrusia" target="_blank"> <i className="fab fa-x-twitter"style={{ color: 'white', marginRight: '5px' }} ></i> </Link>
                    <Link to="https://vk.com/latinox.club" target="_blank"> <i className="fab fa-vk" style={{ color: 'white', marginRight: '5px' }} ></i> </Link>
                </div>

                <div style={{ fontSize: '16px' }}>

                    <span role="img" aria-label="language"></span>
                    <select onChange={(e) => changeLanguage(e.target.value)}>
                        <option value="es">Es</option>
                        <option value="ru">Ру</option>
                        <option value="en">En</option>
                    </select>
                </div>
            </div>

            {/*================= main bar =================*/}

            {/* <div className='main-wrapper' > */}
            <div className={`main-wrapper ${visible ? 'visible' : 'hidden'}`}>
                {/* <nav className={`navbarmob ${touched ? 'visible' : 'hidden'}`}>*/}

                {/* <nav className="navbarmob"> */}
                <nav className={`navbarmob ${visible ? 'visible' : 'hidden'}`}>

                    <div className="brand-and-icon">
                        < Link to="/" className="navbar-brand" style={{ width: '50vw', maxWidth: '240px', minWidth: '120px' }}>
                            <img
                                src="/assets/img/logo/logoapp.webp"
                                srcSet="/assets/img/logo/logoapp@2x.webp 2x"
                                alt="PLAN RUSIA"
                                style={{
                                    width: '80%',       // Ocupa el 100% del contenedor (50vw)
                                    height: 'auto',
                                    objectFit: 'contain',
                                    maxWidth: 'none',     // Elimina límites artificiales 
                                }}
                            />
                        </Link>

                        <button type="button" className="navbar-toggler" onClick={handleToggleClick}>
                            <i className="fas fa-bars" />
                        </button>

                    </div>




                    <div className="navbar-collapse">                            
                        <ul className="navbar-navmob">
                            {/*================= 01 INICIO =================*/}
                            <li>
                                <amob href="/" onClick={handleSubMenuClick}> Inicio </amob>
                            </li>

                            {/*================= 2 BAILES =================*/}
                            <li>
                                <amob href="#" className="menu-link" onClick={handleSubMenuClick}>
                                    Bailemos
                                    <span className="drop-icon">
                                        <i className="fas fa-chevron-down" />
                                    </span>
                                </amob>
                                <div className="sub-menuMob">
                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        {/* <h4>top categories</h4> */}
                                        <ul>
                                            <li><Link to="/events-dance" onClick={() => handleNavLinkClick()}> Fiesta Latina </Link></li>
                                            <li><Link to="/schools-dance" onClick={() => handleNavLinkClick()}> Escuelas de Baile </Link></li>
                                            <li><Link to="/teachers-dance" onClick={() => handleNavLinkClick()}> Profesores de baile </Link></li>
                                            <li><Link to="/video-events" onClick={() => handleNavLinkClick()}> Vídeos </Link></li>
                                            <li><Link to="/photos" onClick={() => handleNavLinkClick()}> Fotos </Link></li>
                                        </ul>
                                    </div>
                                    {/* end of item */}


                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        <h2>Siente la pasión latina</h2>
                                        <div className="imagemob">
                                            <img
                                                src="/assets/img/gif/dance.gif"
                                                alt="Dance image"
                                            /> </div>

                                        <button type="button" className="btn btn-sm btn-primary">
                                            <Link to="/video-events" onClick={() => handleNavLinkClick()}> Todos los Videos! </Link>
                                        </button>
                                    </div>
                                    {/* end of item */}
                                </div>
                            </li>


                            {/*=============== 3 Restaurantes =================*/}

                            <li>
                                <amob href="#" className="menu-link" onClick={handleSubMenuClick}>
                                    Restaurantes
                                    <span className="drop-icon">
                                        <i className="fas fa-chevron-down" />
                                    </span>
                                </amob>
                                <div className="sub-menuMob">
                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        {/* <h4>top categories</h4> */}
                                        <ul>
                                            <li><Link to="/restaurants" onClick={() => handleNavLinkClick()}> Los mejores restaurantes Latinos </Link></li>
                                            <li>
                                                <amob href="#">Clubes y pubs</amob>
                                            </li>
                                            <li>
                                                <amob href="#">Descuentos y promociones</amob>
                                            </li>
                                            <li>
                                                <amob href="#">Recomendados</amob>
                                            </li>
                                        </ul>
                                    </div>
                                    {/* end of item */}

                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        <h2>Fusión de Sabores Auténticos</h2>
                                        <div className="imagemob">
                                            <img
                                                src="/assets/img/restaurant/foodie-food.gif"
                                                alt="product image"
                                            /> </div>

                                        <button type="button" className="btn">
                                            <Link to="/restaurants" onClick={() => handleNavLinkClick()}> Delicioso! </Link>
                                        </button>
                                    </div>

                                </div>
                            </li>

                            {/*=============== 4 IDIOMAS ====================*/}

                            <li>
                                <amob href="#" className="menu-link" onClick={handleSubMenuClick}>
                                    Idioma español
                                    <span className="drop-icon">
                                        <i className="fas fa-chevron-down" />
                                    </span>
                                </amob>
                                <div className="sub-menuMob">
                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        {/* <h4>Escuelas de Español</h4> */}
                                        <ul>
                                            <li><Link to="/schools-spanish" onClick={() => handleNavLinkClick()}> Escuelas de Español </Link></li>
                                            <li><Link to="/teachers-spanish" onClick={() => handleNavLinkClick()}> Profesores de Español </Link></li>
                                            <li><Link to="/events-spanish" onClick={() => handleNavLinkClick()}> Eventos Culturales </Link></li>
                                            <li><Link to="/spanish-courses" onClick={() => handleNavLinkClick()}> Inmersión Linguistica </Link></li>
                                            <li><amob href="#">Traducciones y documentación</amob></li>
                                        </ul>
                                    </div>
                                    {/* end of item */}

                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        <h2>El segundo idioma más hablado del mundo</h2>
                                        <div className="imagemob">
                                            <img
                                                src="/assets/img/language/hispanidad.gif"
                                                alt="product image"
                                            /> </div>

                                        <button type="button" className="btn">

                                            <Link to="/teachers-spanish" onClick={() => handleNavLinkClick()}> Hablemos Español! </Link>
                                        </button>
                                    </div>

                                </div>
                            </li>

                            {/*=============== 5 LOOK====================*/}

                            <li>
                                <amob href="#" className="menu-link" onClick={handleSubMenuClick}>
                                    TIENDAS
                                    <span className="drop-icon">
                                        <i className="fas fa-chevron-down" />
                                    </span>
                                </amob>
                                <div className="sub-menuMob">
                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        {/* <h4>top categories</h4> */}
                                        <ul>
                                            <li><Link to="/store" onClick={() => handleNavLinkClick()}> Moda y belleza </Link></li>
                                            <li><Link to="/store" onClick={() => handleNavLinkClick()}> Soy Latin❤️ </Link></li>
                                            <li><Link to="/store" onClick={() => handleNavLinkClick()}> Productos </Link></li>
                                            <li><Link to="/store" onClick={() => handleNavLinkClick()}> Ferias y Exposiciones</Link></li>
                                            <li><Link to="/store" onClick={() => handleNavLinkClick()}> Promociones para Miembros </Link></li>
                                        </ul>
                                    </div>
                                    {/* end of item */}


                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        <h2>Eres lo más hermoso en el mundo</h2>
                                        <div className="imagemob">
                                            <img
                                                src="/assets/img/gif/store-peru.gif"
                                                alt="product image"
                                            /> </div>

                                        <button type="button" className="btn">
                                            <Link to="/store" onClick={() => handleNavLinkClick()}>  Esto es para ti! </Link>
                                        </button>

                                    </div>

                                </div>
                            </li>

                            {/*=============== 6 ACTUALIDAD ===================*/}

                            <li>
                                <amob href="#" className="menu-link" onClick={handleSubMenuClick}>
                                    Sociedad
                                    <span className="drop-icon">
                                        <i className="fas fa-chevron-down" />
                                    </span>
                                </amob>
                                <div className="sub-menuMob">
                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        {/* <h4>top categories</h4> */}
                                        <ul>
                                            <li>
                                                <amob href="#">Embajadas</amob>
                                            </li>
                                            <li>
                                                <amob href="#">Visas para España y Latinoamérica</amob>
                                            </li>
                                            <li>
                                                <amob href="#">Negocios</amob>
                                            </li>
                                            <li>
                                                <amob href="#">Envíos & Transacciones</amob>
                                            </li>

                                            <li>
                                                <amob href="#">Tengo Un Plan</amob>
                                            </li>

                                        </ul>
                                    </div>
                                    {/* end of item */}

                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        <h2>Explora y vive</h2>
                                        <div className="imagemob">
                                            <img
                                                src="/assets/img/gif/dominican-republic.gif"
                                                alt="product image"
                                            /> </div>

                                        <button type="button" className="btn">
                                            <Link to="/new-year-Latam" onClick={() => handleNavLinkClick()}>   Viajemos! </Link>
                                        </button>
                                    </div>


                                </div>
                            </li>

                            {/*=============== 7 ABOUT ===================*/}

                            <li>
                                <amob href="#" className="menu-link" onClick={handleSubMenuClick}>
                                    HOLA
                                    <span className="drop-icon">
                                        <i className="fas fa-chevron-down" />
                                    </span>
                                </amob>
                                <div className="sub-menuMob">
                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        {/* <h4>top categories</h4> */}
                                        <ul>
                                            <li>
                                                <amob href="#">CLUB - MIEMBROS</amob>
                                            </li>
                                            <li>
                                                <amob href="#">Support Us</amob>
                                            </li>
                                            <li>
                                                <amob href="#">Soluciones Digitales</amob>
                                            </li>
                                            <li>
                                                <amob href="#"> Acerca de </amob>
                                            </li>

                                        </ul>
                                    </div>
                                    {/* end of item */}

                                    {/* item */}
                                    <div className="sub-menuMob-item">
                                        <h2>Comunidad Latina</h2>
                                        <div className="imagemob">
                                            <img
                                                src="/assets/img/gif/latino-flags.gif"
                                                alt="product image"
                                            /> </div>

                                        <button type="button" className="btn">
                                            <Link to="/events-dance" onClick={() => handleNavLinkClick()}>  Gracias! </Link>
                                        </button>
                                    </div>

                                </div>
                            </li>

                            {/*=============== 6 OFERTAS ====================*/}

                            <li>
                                <amob href="#" onClick={handleSubMenuClick} >Foro latino</amob>
                            </li>
                        </ul>
                    </div>

                </nav>
            </div>

            {/*  </div> */}

        </main>

    );
}

export default MenuMobEs;